import { initializeApp } from 'firebase/app';
import {
    getAuth,
    initializeAuth,
    indexedDBLocalPersistence,
    browserLocalPersistence,
    GoogleAuthProvider,
    OAuthProvider,
    FacebookAuthProvider,
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { isNativeApp } from './utils/nativePlatform';

const firebaseConfig = {
    apiKey: "AIzaSyDzKR87R4cNSoL6xBTPpDq6s4d-2MjvvS0",
    authDomain: "memory-mix-up.firebaseapp.com",
    projectId: "memory-mix-up",
    storageBucket: "memory-mix-up.appspot.com",
    messagingSenderId: "99153954821",
    appId: "1:99153954821:web:44b58deb7dca1a6665346c",
    measurementId: "G-69SLCVT8HS"
};

const app = initializeApp(firebaseConfig);

/**
 * Capacitor WKWebView: default getAuth() persistence often hangs forever on
 * signInWithCredential / onAuthStateChanged. Explicit indexedDB persistence
 * is the Firebase-recommended fix for Cordova/Capacitor.
 */
function createAuth() {
    if (isNativeApp()) {
        try {
            return initializeAuth(app, {
                persistence: [indexedDBLocalPersistence, browserLocalPersistence],
            });
        } catch (error) {
            // Already initialized (HMR / double import) — reuse instance.
            console.warn("initializeAuth fell back to getAuth", error);
            return getAuth(app);
        }
    }
    return getAuth(app);
}

export const auth = createAuth();
export const googleProvider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider("apple.com");
appleProvider.addScope("email");
appleProvider.addScope("name");
export const facebookProvider = new FacebookAuthProvider();
facebookProvider.addScope("public_profile");
export const db = getFirestore(app);
export const functions = getFunctions(app);
